import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  // IonMenuButton,
  IonTitle,
  IonContent,
  IonFooter,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonText
} from '@ionic/react';
import { NOT_STARTED, IN_PROGRESS, COMPLETED } from 'src/constants';
import JobTimeline from 'src/components/JobTimeline';
import Icon from 'src/components/Icon';
import WithRecord from 'src/components/WithRecord';
import Subscribe from 'src/components/Subscribe';
import ChatModal from 'src/components/ChatModal';
import MapModal from 'src/components/MapModal';
import JobBar from 'src/components/JobBar';
import { secondsToTime, formatDate, add } from 'src/lib/time';

class Job extends React.Component {
  state = {
    openModal: null
  };

  openModal = (modalName) => this.setState({ openModal: modalName });

  closeModal = () => this.setState({ openModal: null });

  render() {
    const { job } = this.props;
    const { openModal } = this.state;
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/jobs" />
            </IonButtons>
            {/* <IonButtons slot="end">
              <IonMenuButton menu="mainMenu" />
            </IonButtons> */}
            <IonTitle>Murphy</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid fluid>
            <IonRow className="ion-margin-bottom">
              <IonCol size={6}>
                <p className="lead mb-1">Job #: {job.ref_id || 'NA'}</p>
                <p className="lead mb-1">{job.customer.full_name}</p>
                <a
                  className="lead mb-1"
                  href={`tel:${job.customer.phone.replace(/[- )(]/g, '')}`}
                >
                  {job.customer.phone}
                </a>
              </IonCol>
              <IonCol size={6} className="ion-text-right">
                <p className="lead mb-1">
                  Status:{' '}
                  <span className="text-primary">
                    {job.status.charAt(0).toUpperCase() + job.status.slice(1)}
                  </span>
                </p>
                {job.start_time && (
                  <p className="lead mb-1">
                    ETA:{' '}
                    {formatDate(
                      add(job.start_time, job.adjusted_estimate, 'seconds'),
                      'time'
                    )}
                  </p>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
          <div
            style={{
              borderTop: '1px solid #ddd',
              borderBottom: '1px solid #ddd'
            }}
          >
            <JobBar job={job} />
          </div>
          <div
            className="details p-4 ion-text-center"
            style={{
              borderBottom: '1px solid #ddd'
            }}
          >
            <h1 className="mt-0 strong">
              {formatDate(job.scheduled_time, 'iii, MMM d, yyyy')}
            </h1>
            <h3 className="mt-0">{`${formatDate(
              job.scheduled_time,
              'time'
            )} - ${formatDate(
              add(job.scheduled_time, job.original_estimate, 'seconds'),
              'time'
            )}`}</h3>
            <IonText color="medium">
              <h4>{secondsToTime(job.original_estimate)} estimated time</h4>
            </IonText>
            <p className="mb-0">{job.description}</p>
          </div>
          <div className="my-3">
            <JobTimeline job={job} disabled />
          </div>
          <IonGrid
            fluid
            style={{ borderTop: '1px solid #ddd' }}
            className="ion-padding"
          >
            {this.props.job.stages
              .filter((stage) => stage.type === 'travel')
              .map((stage, index) => {
                return (
                  <div key={index} style={{ width: '100%' }}>
                    <p className="strong mb-3">
                      {secondsToTime(stage.original_estimate)} travel time
                    </p>
                    <div className="d-flex mb-3">
                      <div>
                        <span className="dot success mr-3" />
                      </div>
                      <div>
                        <p className="mb-0">{stage.origin_address}</p>
                        {stage.origin_suite && (
                          <p className="mb-0">
                            Apt/Suite: {stage.origin_suite}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div>
                        <span className="dot danger mr-3" />
                      </div>
                      <div>
                        <p className="mb-0">{stage.destination_address}</p>
                        {stage.destination_suite && (
                          <p className="mb-0">
                            Apt/Suite: {stage.destination_suite}
                          </p>
                        )}
                      </div>
                    </div>
                    <IonRow>
                      <IonCol size="4">
                        <IonButton
                          onClick={() => this.openModal(`${index}-origin`)}
                          color="light"
                          expand="block"
                        >
                          <Icon type="street-view" className="text-success" />
                        </IonButton>
                        <MapModal
                          isOpen={openModal === `${index}-origin`}
                          view="street"
                          center={stage.origin_address}
                          onClose={this.closeModal}
                        />
                      </IonCol>
                      <IonCol size="4">
                        <IonButton
                          onClick={() => this.openModal(`${index}-destination`)}
                          color="light"
                          expand="block"
                        >
                          <Icon type="street-view" className="text-danger" />
                        </IonButton>
                        <MapModal
                          isOpen={openModal === `${index}-destination`}
                          view="street"
                          center={stage.destination_address}
                          onClose={this.closeModal}
                        />
                      </IonCol>
                      <IonCol size="4">
                        <IonButton
                          onClick={() => this.openModal(`${index}-travel`)}
                          color="light"
                          expand="block"
                        >
                          <Icon type="map" />
                        </IonButton>
                        <MapModal
                          isOpen={openModal === `${index}-travel`}
                          view="travel"
                          job={job}
                          onClose={this.closeModal}
                        />
                      </IonCol>
                    </IonRow>
                  </div>
                );
              })}
          </IonGrid>
        </IonContent>
        <IonFooter>
          {job.status !== COMPLETED && (
            <IonButton
              routerLink={`/jobs/${job._id}/stages`}
              expand="full"
              className="ion-no-margin"
              color={job.status === IN_PROGRESS ? 'warning' : 'success'}
            >
              {job.status === NOT_STARTED ? 'Start Job' : 'Resume Job'}
            </IonButton>
          )}
          {job.status === COMPLETED && (
            <IonButton
              routerLink={`/jobs/${job._id}/stats`}
              expand="full"
              className="ion-no-margin"
              color="primary"
            >
              View Stats
            </IonButton>
          )}
        </IonFooter>
        <ChatModal
          isOpen={openModal === 'chat'}
          onClose={this.closeModal}
          jobId={job._id}
        />
        <MapModal
          isOpen={openModal === 'map'}
          onClose={this.closeModal}
          job={job}
        />
      </IonPage>
    );
  }
}

export default (routerProps) => {
  const { _id } = routerProps.match.params;
  return (
    <WithRecord
      key={_id}
      service="api/jobs"
      _id={_id}
      render={({ record }) => (
        <Subscribe
          render={({ state }) => (
            <Job
              job={record}
              unseenComments={state.unseenComments.filter(
                (comment) => comment.job_id === _id
              )}
              {...routerProps}
            />
          )}
        />
      )}
    />
  );
};
